import { useEffect, useState } from "react";

import { jwtDecode } from "jwt-decode";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { SparklesIcon } from "../../../../../assets";
import { getLoggedUser, getStoredToken } from "../../../../utils";
import "./index.scss";

export function HeaderLexIAButton() {
  const [isLongText, setIsLongText] = useState(false);

  const loggedUser = useSelector(getLoggedUser);

  const navigate = useNavigate();

  const isIpAccount = loggedUser.origem === "ip_auth";

  const token = getStoredToken();
  const decodedToken = (token ? jwtDecode(token) : {}) as { chat: boolean };
  const chatEnabled = decodedToken?.chat;

  useEffect(() => {
    const runAnimation = () => {
      if (chatEnabled) return;
      setIsLongText(false);

      setTimeout(() => {
        setIsLongText(true);

        setTimeout(() => {
          runAnimation();
        }, 6000);
      }, 20000);
    };

    runAnimation();
  }, []);

  return (
    <a
      href={
        chatEnabled ? `https://ia.lex.com.br/auth/${token}` : "#lex-ia-section"
      }
      target={chatEnabled ? "_blank" : "_self"}
      className="header-lex-ia-button"
      rel="noreferrer"
      onClick={(e) => {
        if (isIpAccount) {
          e.stopPropagation();
          e.preventDefault();

          navigate("/entrar");
        }
      }}
    >
      <span className="header-lex-ia-bg"></span>
      <span className="header-lex-ia-content">
        <span
          className={`header-lex-ia-short ${isLongText ? "hidden" : "visible"}`}
        >
          <SparklesIcon
            className={`header-lex-ia-icon ${isLongText ? "animate-out" : ""}`}
          />
          <span className="header-lex-ia-text-short">
            {chatEnabled ? "Acessar LEX IA" : "Em breve a LEX IA"}
          </span>
        </span>

        <span
          className={`header-lex-ia-long ${isLongText ? "visible" : "hidden"}`}
        >
          <span className="header-lex-ia-text-wrapper">
            {"Conheça o assistente jurídico da LEX Editora!"
              .toUpperCase()
              .split("")
              .map((char, index) => (
                <span
                  key={index}
                  className="header-lex-ia-char"
                  style={{ animationDelay: `${index * 0.05}s` }}
                >
                  {char === " " ? "\u00A0" : char}
                </span>
              ))}
          </span>
        </span>
      </span>
    </a>
  );
}
